module.exports = __webpack_public_path__ + "img/arrow2.24f64c74.png";